import Image from 'next/image';
import cs from 'classnames';
import { usePathname } from 'next/navigation';
import s from './Hero.module.css';
import { HeroEntity } from '@/types/model';
import useIsMobile from '@/hooks/use-is-mobile';
import { ImageLoader } from '@/lib/imageLoader';
import { motion } from 'framer-motion';
import Sello from '@/public/icons/sello.svg';
const Hero = ({
  title,
  subTitle,
  mediaMobile,
  mediaDesktop,
  posterMobile,
  posterDesktop
}: HeroEntity) => {
  const isMobile = useIsMobile();
  const pathname = usePathname();
  const isHome = pathname === '/' || pathname === '/en';
  const isVideoMedia = mediaMobile?.mime === 'video/mp4';
  // isMobile es null en el servidor: hay que distinguir "todavia no se" de
  // "no es mobile". Con !isMobile el HTML del SSR salia siempre con el video
  // desktop y un telefono se bajaba 2,6 MB antes de hidratar.
  const shouldRenderVideo = isVideoMedia && isMobile === false;
  const imageSource = shouldRenderVideo
    ? undefined
    : isVideoMedia
      ? ImageLoader({
          src: isMobile ? posterMobile?.url : posterDesktop?.url,
          width: isMobile ? 900 : 1600,
          quality: isMobile ? 70 : 75
        })
      : isMobile
        ? ImageLoader({ src: mediaMobile?.url })
        : ImageLoader({ src: mediaDesktop?.url });

  return (
    <motion.div
      whileInView={{ opacity: [0, 1], transition: { duration: 1, delay: 0.2 } }}
      className={s.container}>
      {shouldRenderVideo ? (
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster={ImageLoader({
            src: isMobile ? posterMobile?.url : posterDesktop?.url,
            width: isMobile ? 900 : 1600,
            quality: isMobile ? 70 : 75
          })}>
          <source
            src={
              isMobile
                ? ImageLoader({ src: mediaMobile!.url })
                : ImageLoader({ src: mediaDesktop!.url })
            }
            type="video/mp4"
          />
        </video>
      ) : (
        <Image src={imageSource || ''} alt="hero-image" fill priority={isHome} sizes="100vw" />
      )}

      {isHome && (
        <div className={s.svgContainer}>
          {/* sin priority: son 48 KB que competian por ancho de banda con la
              imagen del hero, que es la que define el LCP */}
          <Image src={Sello} alt="Sello" className={s.selloIcon} />
        </div>
      )}

      <div
        className={cs(s.container__info, {
          [s.container__info__is_login]: isHome
        })}>
        <h1
          className={cs(s.container__info__title, {
            [s.container__info__title__is_login]: isHome
          })}>
          {title}
        </h1>
        <p
          className={cs(s.container__info__text, {
            [s.container__info__text__is_login]: isHome
          })}>
          {subTitle}
        </p>
      </div>
    </motion.div>
  );
};

export default Hero;
